// extracted by css-extract-rspack-plugin
export default {"leadingVisual":"IssueTypePickerItemLeadingVisual-module__leadingVisual__LitUX","issueTypeColorIndicator":"IssueTypePickerItemLeadingVisual-module__issueTypeColorIndicator__W1kQd"};